'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFolderOpen = function TiFolderOpen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.2 13.3h-4c-0.7-2-2.5-3.3-4.7-3.3h-10c0-1.8-1.5-3.3-3.3-3.3h-6.9c-2.8 0-5 2.1-5 5v16.6c0 2.9 2.2 5 5 5h20c2.9 0 5.7-2.1 6.4-5l3.6-13.3c0.2-1-0.3-1.7-1.1-1.7z m-30.5 1.7v-3.3c0-1 0.6-1.7 1.6-1.7h6.7c0 1.8 1.5 3.3 3.3 3.3h10c1 0 1.7 0.7 1.7 1.7h-18.5c-1 0-1.8 0.7-2.2 1.7l-2.6 10.5v-12.2z m24.8 12.5c-0.3 1.3-1.8 2.5-3.2 2.5h-20s-0.6-0.3-0.3-1.3l3.2-11.7c0-0.2 0.3-0.3 0.5-0.3h22.8l-3 10.8z' })
        )
    );
};

exports.default = TiFolderOpen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/folder-open.js
// module id = 2067
// module chunks = 0